// src/Tuning/WhyChooseUs/WhyChooseUsAdd/Componates/AddWhyChooseUsForm.jsx
import React from 'react';
import fields from '../../json/WhyChooseUsFields.json';
import FormInput from 'Common/Custom/FormInput';
import FormInputFile from 'Common/Custom/FormInputFile';
import FormSubmitButton from 'Common/Custom/FormSubmitButton';
import PageBody from 'Common/Custom/PageBody';
import { HeadingOne } from 'Common/Custom/HeadingOne';
import FormTextarea from 'Common/Custom/FormTextarea';
import PropTypes from 'prop-types';

const AddWhyChooseUsForm = ({
  values,
  errors,
  handleChange,
  handleFileChange,
  handleSubmit,
  loading,
  imagePreview,
}) => {
  const { formdata } = fields;
  return (
    <PageBody onSubmit={handleSubmit} headerchildren={<HeadingOne>Create Why Choose Us</HeadingOne>}>
      {formdata.map((field) => {
        if (field.type === 'file') {
          return (
            <FormInputFile
              key={field.name}
              field={field}
              handleChange={handleFileChange}
              error={errors[field.name]}
              imagePreview={imagePreview}
            />
          );
        }
        if (field.type === 'textarea') {
          return (
            <FormTextarea
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              error={errors[field.name]}
            />
          );
        }
        // default text input
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}
      <FormSubmitButton label="Create" loading={loading} colSize="col-12" align="end" />
    </PageBody>
  );
};

AddWhyChooseUsForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleFileChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  imagePreview: PropTypes.string,
};

export default AddWhyChooseUsForm;
